export const SET_APP_PROPS = "SET_APP_PROPS";
export type SET_APP_PROPS = typeof SET_APP_PROPS;
